import { GridColDef } from "@mui/x-data-grid";
import api, { SchedulerStatus } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";
import { dayjsUtcFormat, durationText } from "../../utils/util";

type SchedulerLogRow = {
  id: string;
  jobs: number;
  sent: number;
  failed: number;
  started: string;
  finished: string;
  duration: string;
  isError: boolean;
};

export const SchedulerLog = () => {
  const loadData = async (page: number, size: number, sort: string): Promise<PaginationData<SchedulerLogRow>> => {
    const result = await api.systemLog.find({ page, size, sort, eventName: "scheduler" } as any);
    const data: SchedulerLogRow[] = [];
    const count = result ? result.count : 0;
    if (result && result.data && count > 0) {
      for (const row of result.data) {
        if (row.id && row.log) {
          try {
            const status = JSON.parse(row.log) as SchedulerStatus;
            data.push({
              id: row.id,
              jobs: status.forSending ?? 0,
              sent: status.sent?.length ?? 0,
              failed: status.failed?.length ?? 0,
              started:  dayjsUtcFormat(status.startedAt),
              finished: dayjsUtcFormat(status.finishedAt),
              duration: status.durationSeconds ? durationText(status.durationSeconds) : "",
              isError: status.isError ?? false,
            });
          } catch (err) {
            // DO NOTHING
          }
        }
      }
    }
    return { data, count };
  };

  const columns: GridColDef<SchedulerLogRow>[] = [
    { field: "jobs", headerName: "Jobs", width: 50, editable: false, sortable: false, filterable: false, align: "right", headerAlign: "right" },
    { field: "sent", headerName: "Sent", width: 50, editable: false, sortable: false, filterable: false, align: "right", headerAlign: "right" },
    { field: "failed", headerName: "Failed", width: 50, editable: false, sortable: false, filterable: false, align: "right", headerAlign: "right" },
    { field: "started", headerName: "Started UTC", width: 150, editable: false, sortable: false, filterable: false, align: "center", headerAlign: "center" },
    { field: "finished", headerName: "Finished UTC", width: 150, editable: false, sortable: false, filterable: false, align: "center", headerAlign: "center" },
    { field: "duration", headerName: "Duration", width: 150, editable: false, sortable: false, filterable: false, align: "center", headerAlign: "center" },
    { field: "isError", headerName: "error", width: 60, editable: false, sortable: true, filterable: false, align: "center", headerAlign: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
  ];

  return <PaginatedDataGrid loadData={loadData} columns={columns} />;
};
